import type { Dictionary } from '../../i18n/dictionary';

const pl = {
  appName: 'Biblioteka',
  home: 'Start',
  components: 'Komponenty',
  icons: 'Ikony',
  primitives: 'Prymitywy',

  homeTitle: 'Biblioteka — ITLamb',
  componentsTitle: 'Komponenty — Biblioteka — ITLamb',
  storyTitle: (title: string) => `${title} — Biblioteka — ITLamb`,

  intro:
    'Wspólny interfejs projektu: komponenty z `components/`, ikony i klasy z `primitives.css`, renderowane na żywo.',
};

const en: typeof pl = {
  appName: 'Library',
  home: 'Home',
  components: 'Components',
  icons: 'Icons',
  primitives: 'Primitives',

  homeTitle: 'Library — ITLamb',
  componentsTitle: 'Components — Library — ITLamb',
  storyTitle: (title) => `${title} — Library — ITLamb`,

  intro:
    "The project's shared UI: components from `components/`, icons and the classes in `primitives.css`, rendered live.",
};

export const libraryDict: Dictionary<typeof pl> = { pl, en };
